import * as React from 'react';
import { Card, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

interface CustomBlockCardProps {
    index: number;
    disabled: boolean;
    onRemove: () => void;
    children: React.ReactNode;
}

const CustomBlockCard: React.FC<CustomBlockCardProps> = ({ index, disabled, onRemove, children }) => {
    return (
        <Card key={index} size="small" className="custom-block-card">
            <div className="custom-block-card-content">
                <Button
                    type="text"
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    onClick={onRemove}
                    disabled={disabled}
                    className="delete-button"
                />
                {children}
            </div>
        </Card>
    );
};

export default CustomBlockCard;
